import { render, staticRenderFns } from "./AddTalent.vue?vue&type=template&id=69d9dcb9&"
import script from "./AddTalent.vue?vue&type=script&lang=js&"
export * from "./AddTalent.vue?vue&type=script&lang=js&"
import style0 from "./AddTalent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports